import { render, staticRenderFns } from "./Variant.vue?vue&type=template&id=29f33a41"
import script from "./Variant.vue?vue&type=script&lang=js"
export * from "./Variant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports